import { AudioSegmentRepo } from "../domain/AudioSegmentRepo";
import { SessionManifestRepo } from "../domain/SessionManifestRepo";
import { PayloadStore } from "../payload/PayloadStore";

export class RetentionManager {
  constructor(
    private readonly segmentRepo: AudioSegmentRepo,
    private readonly manifestRepo: SessionManifestRepo,
    private readonly payloadStore: PayloadStore
  ) {}

  async markReplaySafeThroughMs(
    sessionId: string,
    replaySafeBoundaryMs: number
  ): Promise<number> {
    return this.segmentRepo.clearReplayFlagThroughMs(sessionId, replaySafeBoundaryMs);
  }

  async markArchiveCommitted(
    sessionId: string,
    uploadId: string,
    committedAt: number
  ): Promise<void> {
    await this.manifestRepo.updateArchiveState(sessionId, "committed", {
      archiveUploadId: uploadId,
      archiveCommittedAt: committedAt,
    });
    await this.segmentRepo.clearArchiveFlags(sessionId, committedAt);
  }

  async compactIfEligible(sessionId: string): Promise<number> {
    const eligible = await this.segmentRepo.listCompactionEligible(sessionId);

    if (eligible.length === 0) {
      return 0;
    }

    const ids: number[] = [];

    for (let index = 0; index < eligible.length; index += 1) {
      const segment = eligible[index];
      if (typeof segment.id === "number") {
        ids.push(segment.id);
      }
      await this.payloadStore.deleteSegment(segment.payloadKey);
    }

    await this.segmentRepo.deleteByIds(ids, Date.now());
    return ids.length;
  }
}
